import type React from 'react';
import { useCoachesList } from '@pages/coaches/coachesList/model';
import { SListBody } from '@pages/coaches/coachesList/styles';
import { CoachListHead } from '@widgets/coaches';
import { Filter } from '@widgets/coaches/filter/index';
import { Header } from '@widgets/header';
import { InfiniteNewList } from '@features/coaches/infinite-list/ui';
import shared from '@shared/styles/sharedStyles.module.scss';

export const CoachesList: React.FC = () => {
  const {
    resetAllParams,
    isSearchingState,
    isFilterOpenState,
    doSelectCity,
    consultationsType,
    setConsultationsType,
    searchCity,
    setSearchCity,
    selectedTags,
    setSelectedTags,
    isMobile,
    searchByName,
    setSearchByName,
    selectedCity,
    selectedPartitions,
    setSelectedPartitions,
    partitions,
    tags,
  } = useCoachesList();

  return (
    <>
      <Header
        MCenter={
          <>
            {(isMobile && isSearchingState[0] && `Поиск`) ||
              (isMobile && isFilterOpenState[0] && `Фильтр`) ||
              (isFilterOpenState[0] && `Специалисты/Фильтр`) ||
              (isSearchingState[0] && `Специалисты/Поиск`) ||
              'Специалисты'}
          </>
        }
        // если фильтр или поиск открыт мы скрываем в навбаре список разделов
        menuClassName={isSearchingState[0] || isFilterOpenState[0] ? shared.hide : undefined}
      />

      <CoachListHead
        filterState={isFilterOpenState}
        searchingState={isSearchingState}
        resetAllParams={resetAllParams}
        searchByName={searchByName}
        setSearchByName={setSearchByName}
      />

      <SListBody>
        <Filter
          partitions={partitions}
          tags={tags}
          selectedPartitions={selectedPartitions}
          onPartitionChange={(partitionId) =>
            selectedPartitions?.at(0) === partitionId
              ? setSelectedPartitions([])
              : setSelectedPartitions([partitionId])
          }
          isOpen={isFilterOpenState[0]}
          searchCityState={[searchCity, setSearchCity]}
          consultationsTypeState={[consultationsType, setConsultationsType]}
          selectedTagsState={[selectedTags, setSelectedTags]}
          doSelectCity={doSelectCity}
          resetAllParams={resetAllParams}
        />

        <InfiniteNewList
          partitions={selectedPartitions}
          isFilterOpen={isFilterOpenState[0]}
          consultationType={consultationsType}
          searchByName={searchByName}
          tags={selectedTags}
          selectedCity={selectedCity}
        />
      </SListBody>
    </>
  );
};
